import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import LegalCreateForm from "./create";
import LegalEditForm from "./edit";
import { LegalDocDto } from "src/store/legal/type";
import { getLegalListSaga } from "src/store/legal/saga";

const LegalPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<LegalDocDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<LegalDocDto>();

  const columns = [
    { text: t("Legal.Slug"), dataField: "Slug" },
    { text: t("Legal.Order"), dataField: "Order" },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Legal.PageTitle")}
        metaTag={t("Legal.PageTitle")}
        gridProps={{
          addTitle: t("Legal.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getLegalListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id: string, row: LegalDocDto) => {
              // Liste satırı DataJson dahil tüm alanları taşır → ekstra GET gerekmez.
              setSelected(row);
              setShowEdit(true);
            },
          },
        }}
      />
      <LegalCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch,
            message: m,
            action: getLegalListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <LegalEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch,
              message: m,
              action: getLegalListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default LegalPage;
